import React from 'react';

const metrics = ["Complaints", "Complaint % Contribution", "NB % Contribution"];

const ComplaintsTable = ({ data }) => {

  const productTypes = Object.keys(data["Product Type"]);
  const financialYears = Object.keys(data["Product Type"][productTypes[0]])

  // Calculate totals
  const totals = {};
  productTypes.forEach(product => {
    financialYears.forEach(year => {
      const yearData = data["Product Type"][product][year];
      metrics.forEach(metric => {
        const value = parseFloat(yearData[metric].replace('%', '')) || 0;
        if (!totals[year]) totals[year] = {};
        if (!totals[year][metric]) totals[year][metric] = 0;
        totals[year][metric] += value;
      });
    });
  });

  return (
    <table border={1} cellPadding={8} style={{ borderCollapse: 'collapse', width: '200px', height: "90%", }}>
      <thead>
        <tr>
          <th rowSpan={2}>Product Type</th>
          {financialYears.map(year => (
            <th key={year} colSpan={metrics.length}>{year}</th>
          ))}
        </tr>
        <tr>
          {financialYears.map(year =>
            metrics.map(metric => (
              <th key={`${year}-${metric}`}>{metric}</th>
            ))
          )}
        </tr>
      </thead>
      <tbody>
        {productTypes.map(product => (
          <tr key={product}>
            <td>{product}</td>
            {financialYears.map(year =>
              metrics.map(metric => (
                <td key={`${product}-${year}-${metric}`}>
                  {data["Product Type"][product][year]?.[metric] || '-'}
                </td>
              ))
            )}
          </tr>
        ))}
        <tr>
          <td><strong>Total</strong></td>
          {financialYears.map(year =>
            metrics.map(metric => (
              <td key={`total-${year}-${metric}`}>
                {metric.includes('%') ? `${totals[year][metric].toFixed(0)}%` : totals[year][metric]}
              </td>
            ))
          )}
        </tr>
      </tbody>
    </table>
  );
};

export default ComplaintsTable;
